import { createContext } from 'react';

export interface AppConfigurationsData {
  feature_flags: {
    llm_summary?: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface AppConfigurationsContextInterface {
  appConfigurations: AppConfigurationsData | null;
  appConfigurationsLoading: boolean;
}

export const AppConfigurationsContext =
  createContext<AppConfigurationsContextInterface>({
    appConfigurations: null,
    appConfigurationsLoading: false,
  });
